import React from 'react';
import { ExpenseContainer } from 'Components/ComponentLibrary/Organisms/Expense';
import Navigator from '../UI/Navigator';

const Expense = () => {
  return (
    <Navigator>
      <ExpenseContainer />
    </Navigator>
  );
};

export default Expense;
